import { Routes } from "@angular/router";
import { authenticationRoutes } from "@app/applications/authentication/authentication.routes";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@shared/general/translation/constants/translation.constant";
import { settingRoutes } from "@app/applications/settings/setting.routes";
import { usersRoutes } from "./applications/users/users.routes";
import { authRoutes } from "./applications/auth/auth.routes";
import { AuthGuard } from "@shared/auth/guards/auth.guard";
import { companyHierarchyRoutes } from "./applications/company-hierarchy/company-hierarchy.routes";
import { EAccessType } from "@shared/auth/enums/auth.enum";
import { MainLayoutComponent } from "@shared/general/layouts/main-layout/main-layout.component";
import { AuthLayoutComponent } from "@shared/general/layouts/auth-layout/auth-layout.component";
import { dashboardRoutes } from "./applications/dashboard/dashboard.routes";
import { archiveRoutes } from "@app/applications/archive/archive.routes";
import { APP_ROUTE_PATHS } from "@app/app-route-paths";
import { stockRoutes } from "@app/applications/stock/stock.routes";
import { newsRoutes } from "@app/applications/news/news.routes";
import { newsSettingRoutes } from "./applications/news/news-setting.routes";
import { homeDashboardRoutes } from "./applications/home-dashboard/home-dashboard.routes";
import { customQuotationRoutes, quotationRoutes } from "@app/applications/quotation/quotation.routes";
import { stockTypeRoutes } from "./applications/stock/domains/stock-type/stock-type.routes";
import { StockTypeRoutePaths } from "./applications/stock/domains/stock-type/stock-type-route-paths";
import { ocrQuotationRoutes } from "./applications/ocr/domains/ocr-quotation/ocr-quotation.routes";
import { websiteOfferRoutes } from "@app/applications/quotation/domains/website-offers/website-offer.routes";
import { StockStatisticsRoutePaths } from "./applications/stock/domains/stock-statistics/stock-statistics-route-paths";
import { stockStatisticsRoutes } from "./applications/stock/domains/stock-statistics/stock-statistics.routes";

export const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    resolve: {
      transition: loadTranslationResolver(TRANSLATION_PATHS.ROOT),
    },
    canActivate: [AuthGuard],
    data: {
      authGuardOptions: {
        allowAccessWithoutSession: false,
        // Allow both full access and verification access
        accessType: [EAccessType.FullAccess],
        // For verification access, we want to redirect appropriately
        redirectTo: "/auth/login",
      },
    },
    children: [
      {
        path: APP_ROUTE_PATHS.HOME_DASHBOARD,
        children: homeDashboardRoutes,
      },
      {
        path: APP_ROUTE_PATHS.SETTINGS,
        children: [
          ...authenticationRoutes,
          ...usersRoutes,
          ...settingRoutes,
          ...companyHierarchyRoutes,
          {
            path: APP_ROUTE_PATHS.NEWS,
            children: newsSettingRoutes,
          },
          {
            path: StockTypeRoutePaths.STOCK_TYPE_ROUTE,
            children: stockTypeRoutes,
          },
          {
            path: StockStatisticsRoutePaths.STOCK_STATISTICS_ROUTE,
            children: stockStatisticsRoutes,
          },
        ],
      },
      { path: APP_ROUTE_PATHS.WEBSITE_OFFER, children: websiteOfferRoutes },
      { path: APP_ROUTE_PATHS.CUSTOM_QUOTATION, children: customQuotationRoutes },
      {
        path: APP_ROUTE_PATHS.OCR_QUOTATION,
        children: ocrQuotationRoutes,
      },
      {
        path: APP_ROUTE_PATHS.ARCHIVE,
        children: archiveRoutes,
      },
      {
        path: APP_ROUTE_PATHS.QUOTATION,
        children: quotationRoutes,
      },
      {
        path: APP_ROUTE_PATHS.DASHBOARD,
        children: [...dashboardRoutes],
      },
      {
        path: APP_ROUTE_PATHS.STOCK,
        children: stockRoutes,
      },
      {
        path: APP_ROUTE_PATHS.NEWS,
        children: newsRoutes,
      },
    ],
  },
  {
    path: APP_ROUTE_PATHS.AUTH,
    component: AuthLayoutComponent,
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.AUTH]),
    },
    children: [...authRoutes],
  },
  { path: "**", redirectTo: "", pathMatch: "full" },
];
